import { useQuery } from '@tanstack/react-query'
import { getContributions } from '../api'
import { useMemo } from 'react'

const DEFAULT_CONTRIBUTION_GROUPS = ['Default']

export function useClientContributionGroups(
  clientPublicKey?: string | null,
  planYear?: number
) {
  const queryKey = ['recruiting-contribution-groups', clientPublicKey, planYear]

  const { data, isLoading, isError } = useQuery({
    queryKey,
    queryFn: () => getContributions(clientPublicKey, planYear),
    enabled: !!clientPublicKey && planYear != null && planYear > 0,
    staleTime: 5 * 60 * 1000,
  })

  const isLookupFailed = isError && data == null

  const contributionGroups = useMemo(() => {
    if (isLookupFailed) {
      return []
    }

    const contributionGroupSet = new Set<string>()

    const activeContribution = data?.find(
      (contribution) => contribution.isActive
    )

    if (activeContribution) {
      activeContribution.rows.forEach((row) => {
        if (row.ContributionGroup) {
          contributionGroupSet.add(row.ContributionGroup)
        }
      })
    }
    return contributionGroupSet.size > 0
      ? Array.from(contributionGroupSet)
      : DEFAULT_CONTRIBUTION_GROUPS
  }, [data, isLookupFailed])

  return {
    contributionGroups,
    isLoading,
    isLookupFailed,
  }
}
